import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { MeetingApiService } from '../services/meeting-api.service';
import { MeetingHolidayApiService } from '../services/meeting-holiday-api.service';
import { MeetingAvailabilityOverrideApiService } from '../services/meeting-availability-override-api.service';
import { MeetingHolidayResponse, MeetingUserAvailabilityOverrideResponse } from '../models/meeting.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { MeetingDetailModalComponent } from "../meeting-detail-modal/meeting-detail-modal.component";
import { MeetingCancelDialogComponent } from "../shared/meeting-cancel-dialog/meeting-cancel-dialog.component";
import { MeetingRescheduleDialogComponent } from "../shared/meeting-reschedule-dialog/meeting-reschedule-dialog.component";
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-meeting-calendar',
  standalone: true,
  imports: [CommonModule,
    RouterModule,
    MeetingDetailModalComponent,
    MeetingCancelDialogComponent,
    MeetingRescheduleDialogComponent,
    FormsModule
  ],
  templateUrl: './meeting-calendar.component.html',
})
export class MeetingCalendarComponent implements OnInit {

  currentDate = new Date();
  currentMonth = this.currentDate.getMonth();
  currentYear = this.currentDate.getFullYear();

  days: any[] = [];
  meetings: any[] = [];

  // INC 7: fechas bloqueadas — feriados del negocio + excepciones de
  // disponibilidad del usuario actual (isAvailable=false)
  holidays: MeetingHolidayResponse[] = [];
  unavailableOverrides: MeetingUserAvailabilityOverrideResponse[] = [];

  selectedDate: Date = new Date();
  selectedMeetings: any[] = [];

  //Modal
  selectedMeeting: any = null;
  isModalOpen = false;

  // Acciones cancelar / reprogramar (INC 49)
  showCancelDialog = false;
  showRescheduleDialog = false;
  accionMeeting: any = null;

  // Variables para filtrar por rango de fechas
  startFilterDate: string = '';
  endFilterDate: string = '';

  // INC 74 — alcance del calendario: 'ALL' (todas, default) o 'MINE' (mis reuniones).
  scope: 'MINE' | 'ALL' = 'ALL';

  constructor(
    private meetingApi: MeetingApiService,
    private holidayApi: MeetingHolidayApiService,
    private overrideApi: MeetingAvailabilityOverrideApiService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
     const currentYear = new Date().getFullYear();

  for (let i = currentYear - 5; i <= currentYear + 5; i++) {
    this.years.push(i);
  }

    this.loadMeetings();
    this.loadBlockedDates();

  }

  // INC 7: cargar feriados activos del negocio y días no disponibles del usuario
  private loadBlockedDates(): void {
    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.holidayApi.listActive(businessId).subscribe({
      next: (holidays) => {
        this.holidays = holidays;
        this.generateCalendar();
      },
      error: () => console.error('Error cargando feriados'),
    });

    if (user?.id) {
      this.overrideApi.list(user.id, businessId, 0, 200).subscribe({
        next: (page) => {
          this.unavailableOverrides = (page.content || []).filter(o => o.isAvailable === false);
          this.generateCalendar();
        },
        error: () => console.error('Error cargando excepciones de disponibilidad'),
      });
    }
  }

  /** Devuelve el motivo de bloqueo de una fecha, o null si está libre. */
  getDayBlock(date: Date): { kind: 'holiday' | 'override'; label: string } | null {
    const iso = this.toDateOnly(date);
    const monthDay = iso.slice(5); // MM-DD para feriados recurrentes
    const holiday = this.holidays.find(h =>
      h.isRecurring ? (h.holidayDate || '').slice(5) === monthDay : h.holidayDate === iso
    );
    if (holiday) {
      return { kind: 'holiday', label: `Feriado: ${holiday.name}` };
    }
    const override = this.unavailableOverrides.find(o => o.overrideDate === iso);
    if (override) {
      return {
        kind: 'override',
        label: override.reason ? `No disponible: ${override.reason}` : 'No disponible',
      };
    }
    return null;
  }

  onMonthChange() {
  this.loadMeetings();
}

  loadMeetings() {
  const user = this.authService.getCurrentUser();
  const businessId = user?.businessId || 1;

  // Funcion para filtrar por rango de fechas
  let start: Date;
  let end: Date;

  //  Si hay filtro, usarlo
  if (this.startFilterDate && this.endFilterDate) {
    start = new Date(this.startFilterDate);
    end = new Date(this.endFilterDate);
    end.setHours(23, 59, 59, 999);
  } else {
    // si no, usar el mes actual
    start = new Date(this.currentYear, this.currentMonth, 1);
    end = new Date(this.currentYear, this.currentMonth + 1, 0);
  }

  //
  start.setHours(0, 0, 0);
  end.setHours(23, 59, 59, 999);

  const startDate = this.formatDateForBackend(start);
  const endDate = this.formatDateForBackend(end);

  console.log('ENVIANDO:', startDate, endDate); 

  this.meetingApi.getMeetingsByDateRange(
    businessId,
    startDate,
    endDate,
    this.scope
  ).subscribe({
    next: (data: any) => {
  console.log('DATA BACKEND:', data);

  this.meetings = data.content || []; 
  this.generateCalendar();
},
    error: (err) => {
      console.error('ERROR BACKEND:', err);
      this.meetings = [];
      this.generateCalendar();
    }
  });
}
// Muestra los datos 
 formatDateForBackend(date: Date): string {
  // INC 18: sin la 'Z' el backend interpreta el datetime como UTC "naive"
  // y el rango consultado queda corrido (-5h en Lima)
  return date.toISOString().slice(0, 19) + 'Z';
}

  generateCalendar() {
  const firstDay = new Date(this.currentYear, this.currentMonth, 1);
  const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0);

  const start = new Date(firstDay);
  start.setDate(start.getDate() - start.getDay());

  const end = new Date(lastDay);
  end.setDate(end.getDate() + (6 - end.getDay()));

  this.days = [];

  let current = new Date(start);

  while (current <= end) {
    const date = new Date(current); 
    date.setHours(0, 0, 0, 0);

    const dayMeetings = this.meetings.filter(m => {
      const md = new Date(this.fixDate(m.datetimeStart));
      return md.getFullYear() === date.getFullYear() &&
             md.getMonth() === date.getMonth() &&
             md.getDate() === date.getDate();
    });

    this.days.push({
      date,
      number: date.getDate(),
      isCurrentMonth: date.getMonth() === this.currentMonth,
      isToday: date.toDateString() === new Date().toDateString(),
      meetings: dayMeetings,
      blocked: this.getDayBlock(date)
    });

    current.setDate(current.getDate() + 1); 
  }
}
  toDateOnly(date: Date): string {
  return date.getFullYear() + '-' +
         (date.getMonth() + 1).toString().padStart(2,'0') + '-' +
         date.getDate().toString().padStart(2,'0');
}

  selectDate(date: Date) {
  // INC 7: no permitir seleccionar días bloqueados (feriado u override no disponible)
  if (this.getDayBlock(date)) return;

  this.selectedDate = date;

  this.selectedMeetings = this.meetings.filter(m => {
    const md = new Date(this.fixDate(m.datetimeStart));

    return md.getFullYear() === date.getFullYear() &&
           md.getMonth() === date.getMonth() &&
           md.getDate() === date.getDate();
  });
}

getMeetingsCount(date: Date): number {
  return this.meetings.filter(m => {
    const md = new Date(this.fixDate(m.datetimeStart));
    md.setHours(0,0,0,0);
    return this.toDateOnly(md) === this.toDateOnly(date);
  }).length;
}

  nextMonth() {
    this.currentMonth++;
    if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }
    this.loadMeetings();
  }

  prevMonth() {
    this.currentMonth--;
    if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    }
    this.loadMeetings();
  }

  fixDate(dateStr: string): string {
  if (!dateStr) return '';
  return dateStr.replace(' ', 'T');
}

  viewMeeting(meeting: any) {
    this.router.navigate(['/meeting/editar', meeting.id]);
  }

  formatHour(dateStr: string): string {
    const d = new Date(this.fixDate(dateStr));
    return d.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' });
  }

  getMonthName(): string {
    return new Date(this.currentYear, this.currentMonth)
      .toLocaleString('es-ES', { month: 'long', year: 'numeric' });
  }
  getMeetingColor(typeId: number): string {
  switch (typeId) {
    case 1: return 'bg-blue-200 text-blue-800';
    case 2: return 'bg-green-200 text-green-800';
    case 3: return 'bg-yellow-200 text-yellow-800';
    case 4: return 'bg-red-200 text-red-800';
    default: return 'bg-gray-200 text-gray-800';
    }
  }

  openMeetingDetail(meeting: any) {
    this.selectedMeeting = meeting;
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  // ─── Acciones Reprogramar / Cancelar (INC 49) ──────────────────
  reprogramarReunion(meeting: any): void {
    this.accionMeeting = meeting;
    this.showRescheduleDialog = true;
  }

  cancelarReunion(meeting: any): void {
    this.accionMeeting = meeting;
    this.showCancelDialog = true;
  }

  cerrarCancelDialog(): void {
    this.showCancelDialog = false;
    this.accionMeeting = null;
  }

  cerrarRescheduleDialog(): void {
    this.showRescheduleDialog = false;
    this.accionMeeting = null;
  }

  onAccionConfirmada(): void {
    this.showCancelDialog = false;
    this.showRescheduleDialog = false;
    this.accionMeeting = null;
    // Refrescar el calendario y el panel de detalle del día seleccionado
    this.loadMeetings();
    if (this.selectedDate) {
      const sel = this.selectedDate;
      setTimeout(() => this.selectDate(sel), 0);
    }
  }

  //Filtros
  months = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
  ];

  years: number[] = [];

  //Metodos para filtrar por rango de fechas
  onFilterChange() {
  this.loadMeetings();
  }

  // INC 74 — cambiar entre "Mis reuniones" (MINE) y "Todas" (ALL).
  setScope(scope: 'MINE' | 'ALL'): void {
    if (this.scope === scope) return;
    this.scope = scope;
    this.loadMeetings();
    if (this.selectedDate) {
      const sel = this.selectedDate;
      setTimeout(() => this.selectDate(sel), 0);
    }
  }

  clearFilters() {
    this.startFilterDate = '';
    this.endFilterDate = '';
    this.loadMeetings();
  }
 
}